module.exports = __webpack_public_path__ + "static/media/country_ro.4b36df6d.webp";